import React, { FC, PropsWithChildren } from 'react';

type PauseProps = {
  /** The color of the icon. */
  color?: string;
};

const Pause: FC<PropsWithChildren<PauseProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="100%" viewBox="0 0 6 10" width="100%" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0V9.5" stroke={color} strokeWidth="1.5" />
    <path d="M5 0V9.5" stroke={color} strokeWidth="1.5" />
  </svg>
);

export default Pause;
